<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td> {{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearings.details.business_day') }}</label></td>
      <td>{{ details.business_day | dateOnly }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearings.details.tenant_operator') }}</label></td>
      <td>{{ details.tenant_operator }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearings.details.account_id') }}</label></td>
      <td>
        <router-link
          :to="{name: 'account-journeys', params: {id: details.account_id}}">
          {{ details.account_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearings.details.card_token') }}</label></td>
      <td>{{ details.card_token }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearingEntries.details.journey_operation_ts') }}</label></td>
      <td>{{ details.journey_operation_ts | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearingEntries.details.amount') }}</label></td>
      <td>{{ details.amount | money }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearingEntries.details.ticket_description') }}</label></td>
      <td>{{ details.ticket_description }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearingEntries.details.clearing_attempt') }}</label></td>
      <td>{{ details.clearing_attempt }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearingEntries.details.emv_tap_id') }}</label></td>
      <td><router-link
        :to="{name: 'account-emv-tap-details', params: {id: details.account_id, resource_id: details.id}}">
        {{ details.id }}
      </router-link></td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearings.details.emv_cut_over_id') }}</label></td>
      <td>
        <router-link v-if="details.emv_cut_over_id"
                     :to="{name: 'emvCutOver', params: {id: details.emv_cut_over_id}}">
          {{ details.emv_cut_over_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('emvClearingEntries.details.emv_clearing_id') }}</label></td>
      <td>
        <router-link v-if="details.emv_clearing_id"
                     :to="{name: 'account-emv-clearing', params: {id: details.account_id, resource_id: details.emv_clearing_id}}">
          {{ details.emv_cut_over_id }}
        </router-link>
      </td>
    </tr>
  </table>
</template>
<script>

export default {
  name: 'EmvClearingEntryDetails',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style></style>
